import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { PrintGSTReportComponent } from '../../print-gstreport/print-gstreport.component';

@Component({
  selector: 'app-print-javak',
  templateUrl: './print-javak.component.html',
  styleUrls: ['./print-javak.component.scss'],
})
export class PrintJavakComponent implements OnInit {
  printJavakData;
  // tempData = [];
  tempDataTotal = {
    name: 'एकूण',
    totalVprati: 0,
    totalVkprati: 0,
    totalSbhet: 0,
    totalAikun: 0,
    allAdditionTotal: 0,
    totalJadaAnk: 0,
    totalJadaSale: 0,
    totalJadaSBhet: 0,
  };
  tempData = [
    { name: 'रेल्वे', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    { name: 'एस. टी', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    { name: 'ट्रान्सपोर्ट', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    { name: 'ट्रॅव्हल्स', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    { name: 'हस्ते', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    // { name: 'पोस्ट ', vprati: 0, vkprati: 0, sbprati: 0, aikun: 0 },
    { name: 'पोस्ट पार्सल', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },
    { name: 'मॅगझीन पोस्ट', vprati: 0, vkprati: 0, sbprati: 0, jadaAnk: 0, jadaSale: 0, jadaSBhet: 0, aikun: 0 },

  ];
  // { name: '', vprati: 36, vkprati: 0, sbprati: 29, aikun: 65 },

  testData = [];
  // testData = [
  //   { name: 'जाहिरात ', aikun: 0 },
  //   { name: 'जादा विक्री ', aikun: 0 },
  //   { name: 'संपादकीय', aikun: 0 },
  //   { name: 'कार्यालय', aikun: 0 },
  // ];

  testData2 = [];
  // testData2 = [
  //   { name: 'एकूण जावक', aikun: 9997 },
  //   { name: 'छपाई', aikun: 10100 },
  //   { name: 'शिल्लक ', aikun: 130 },
  // ];
  sbhetData;
  startDate = '';
  endDate = '';
  delivery_mode = 'हस्ते';
  totalVargini = 0;
  totalVikri = 0;
  totalSBhet = 0;
  totalAikun = 0;
  disRepData: any;
  praticount: any;
  chapai: any;
  magzineCount: any;
  magCount: any;
  totalMagzineCount = 0;
  totalJadaVargini = 0;
  totalJadaVikriVargini = 0;
  totalJadaSBhetVargini = 0;


  constructor(
    private dialogref: MatDialogRef<PrintGSTReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {


    console.log(this.data, "javak ngon")

    this.printJavakData = this.data['data'];

    // this.totalVargini = Object.keys(this.printJavakData).length;

    this.totalVargini = this.printJavakData.TotalVargni;
    this.totalSBhet = this.printJavakData.TotalSBhet;
    this.totalVikri = this.printJavakData.TotalVikari;
    
    // this.totalJadaVargini = this.printJavakData.totalJadaVargini;
    // this.totalJadaVikriVargini = this.printJavakData.totalJadaVikriVargini;
    // this.totalJadaSBhetVargini = this.printJavakData.totalJadaSBhetVargini;


    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    const req: any = {
      "issue_date_to": this.endDate
    }
    this.service.getJavakprati(req).subscribe((res) => {
      this.praticount = res[0];
      // console.log("praticount", this.praticount)
      debugger
      this.chapai = this.praticount['total_prati']


    })
    const req1: any = {
      "issue_date_to": this.endDate
    }
    this.service
      .getDistributionRepresentativeJavakData(req1)
      .subscribe((res) => {
        this.printJavakData = res;
        console.log(this.printJavakData, "javakdata");

        console.log(this.printJavakData)

        // this.printJavakData.map((a) => {

        //   if (a.dis_s_bhet != null) {
        //     this.totalSBhet += parseInt(a.dis_s_bhet);
        //     // console.log(a.dis_s_bhet, "a.dis_s_bhet")
        //   }
        // });

        this.totalAikun = this.totalVargini + this.totalSBhet + this.totalVikri;
        // console.log(this.totalSBhet, "this.totalSBhet")

        this.setJavakData();
      });

    //Magzine Count
    const req2: any = {
      "issue_date_to": this.endDate
    }
    this.service.getMagzineJavakprati(req2).subscribe((res) => {
      this.magCount = res;
      this.magzineCount = +res.total_count || 0;
      // console.log("magCount", this.magCount)

      // ✅ Assign to tempData row
      const magRow = this.tempData.find(x => x.name === 'मॅगझीन पोस्ट');
      if (magRow) {
        magRow.vprati = this.magzineCount;   // or vkprati based on requirement
        magRow.aikun = this.magzineCount;
      }

       // ✅ IMPORTANT: recalculate totals after update
  this.recalculateTotals();
    })
    this.getPrintOrderData();


    // this.service
    //   .getDistributionRepresentativeSBhetHastewise()
    //   .subscribe((res) => {
    //     this.sbhetData = res;
    //     // console.log(this.disRepData);
    //   });

    // this.printJavakData = this.data['data'].filter((a) => {
    //   return a['delivery_mode'] === this.delivery_mode;
    // });
    // console.log(this.printJavakData);


  }

  recalculateTotals() {
  this.tempDataTotal = {
    name: 'Total',
    totalVprati: 0,
    totalVkprati: 0,
    totalSbhet: 0,
    totalAikun: 0,
    allAdditionTotal: this.tempDataTotal.allAdditionTotal || 0,
    totalJadaAnk: 0,
    totalJadaSale: 0,
    totalJadaSBhet: 0
  };

  this.tempData.forEach(a => {
    this.tempDataTotal.totalVprati += a.vprati || 0;
    this.tempDataTotal.totalVkprati += a.vkprati || 0;
    this.tempDataTotal.totalSbhet += a.sbprati || 0;
    this.tempDataTotal.totalAikun += a.aikun || 0;

    this.tempDataTotal.totalJadaAnk += a.jadaAnk || 0;
    this.tempDataTotal.totalJadaSale += a.jadaSale || 0;
    this.tempDataTotal.totalJadaSBhet += a.jadaSBhet || 0;
  });
}

  totalPrati = 0;
  //Old Correct Code 
  // getPrintOrderData() {
  //   if (this.startDate != '' && this.endDate != '') {
  //     this.service
  //       .getPrintOrderDataByDate(this.startDate, this.endDate)
  //       .subscribe((res: any) => {
  //         console.log(res);
  //         this.totalPrati = 0;
  //      if(res.type_data!=undefined){
  //       res.type_data.map((a) => {
  //         if (a.name === 'जाहिरात स. भेट') {
  //           this.testData.push({ name: 'जाहिरात', aikun: a.prati });
  //           this.totalPrati += parseInt(a.prati);
  //         } else if (a.name === 'जादा विक्री') {
  //           this.testData.push({ name: 'जादा विक्री', aikun: a.prati });
  //           this.totalPrati += parseInt(a.prati);
  //         } else if (a.name === 'स सप्रेम भेट') {
  //           this.testData.push({ name: 'संपादकीय', aikun: a.prati });
  //           this.totalPrati += parseInt(a.prati);
  //         } else if (a.name === 'कार्यालय') {
  //           this.testData.push({ name: 'कार्यालय', aikun: a.prati });
  //           this.totalPrati += parseInt(a.prati);
  //         }
  //       });
  //      }

  //        if(res.print_data!=undefined){
  //         this.testData2.push({
  //           name: 'एकूण जावक',
  //           aikun: this.tempDataTotal['totalAikun'] + this.totalPrati,
  //         });
  //         this.testData2.push({
  //           name: 'छपाई',
  //           aikun: res.print_data['total_prati'],
  //         });
  //         this.testData2.push({
  //           name: 'शिल्लक',
  //           aikun: Math.abs(
  //             this.tempDataTotal['totalAikun'] +
  //               this.totalPrati -
  //               parseInt(res.print_data['total_prati'])
  //           ),
  //         });
  //        }
  //       });
  //   }
  // }

  //New Correct Code
  getPrintOrderData() {
    if (this.startDate != '' && this.endDate != '') {
      this.service
        .getPrintOrderDataByDate(this.startDate, this.endDate)
        .subscribe((res: any) => {
          console.log(res);
          this.totalPrati = 0;
          if (res.type_data != undefined) {
            res.type_data.map((a) => {
              if (a.name === 'जाहिरात स. भेट') {
                this.testData.push({ name: 'जाहिरात', aikun: a.prati });
                this.totalPrati += parseInt(a.prati);
              } else if (a.name === 'जादा विक्री') {
                this.testData.push({ name: 'जादा विक्री', aikun: a.prati });
                this.totalPrati += parseInt(a.prati);
              } else if (a.name === 'स सप्रेम भेट') {
                this.testData.push({ name: 'संपादकीय', aikun: a.prati });
                this.totalPrati += parseInt(a.prati);
              } else if (a.name === 'कार्यालय') {
                this.testData.push({ name: 'कार्यालय', aikun: a.prati });
                this.totalPrati += parseInt(a.prati);
              }
            });
          }

          if (res.print_data != undefined) {
            this.testData2.push({
              name: 'एकूण जावक',
              aikun: this.tempDataTotal['totalAikun'] + this.totalPrati,
            });
            this.testData2.push({
              name: 'छपाई',
              aikun: res.print_data['total_prati'],
            });
            this.testData2.push({
              name: 'शिल्लक',
              aikun: Math.abs(
                this.tempDataTotal['totalAikun'] +
                this.totalPrati -
                parseInt(res.print_data['total_prati'])
              ),
            });
          }
        });
    }
  }

  //OLD CODE 
  //   setJavakData() {
  //     // console.log(this.printJavakData);
  //      const req1:any = {
  //       "issue_date_to":this.endDate
  //     }
  //     let testingData = this.uniqueData(
  //       this.printJavakData,
  //       (a) => a.delivery_mode
  //     );
  //     for (let index = 0; index < testingData.length; index++) {
  //       // console.log(
  //       //   this.printJavakData.filter((a) => {
  //       //     return a.delivery_mode == testingData[index]['delivery_mode'];
  //       //   })
  //       // );
  //       let subData = this.printJavakData.filter((a) => {
  //         return a.delivery_mode == testingData[index]['delivery_mode'];
  //       });

  //       let data = this.uniqueData(subData, (a) => a.dis_mode);
  //       // console.log(data);

  //       for (let index = 0; index < Object.keys(data).length; index++) {
  //         let data1 = subData.filter((a) => {
  //           return a.dis_mode == data[index]['dis_mode'];
  //         });
  //         // console.log(data1);

  //         let totalsbhet = 0;
  //         data1.map((a) => {
  //           if (a.dis_s_bhet != null) {
  //             // this.totalSBhet = this.totalSBhet + parseInt(a.s_bhet);
  //             totalsbhet += parseInt(a.dis_s_bhet);
  //           }
  //         });
  //         if (
  //           data[index]['dis_mode'] == 'हस्ते' &&
  //           data[index]['delivery_mode'] !== 'टपाल'
  //         ) {
  //           this.addToObject('हस्ते', Object.keys(data1).length, totalsbhet);
  //         } else if (
  //           data[index]['dis_mode'] == 'ट्रान्सपोर्ट' &&
  //           data[index]['delivery_mode'] !== 'टपाल'
  //         ) {
  //           this.addToObject('वाहतूक', Object.keys(data1).length, totalsbhet);
  //         } else if (
  //           (data[index]['dis_mode'] == 'टपाल' &&
  //             data[index]['delivery_mode'] !== 'टपाल') ||
  //           data[index]['delivery_mode'] == 'टपाल'
  //         ) {
  //           this.addToObject('पोस्ट', Object.keys(data1).length, totalsbhet);
  //         } else if (
  //           (data[index]['delivery_mode'] !== 'टपाल' &&
  //             data[index]['dis_mode'] == 'एस . टी') ||
  //           (data[index]['delivery_mode'] !== 'टपाल' &&
  //             data[index]['dis_mode'] == 'एस. टी')
  //         ) {
  //           this.addToObject('एस. टी', Object.keys(data1).length, totalsbhet);
  //         } else if (
  //           data[index]['delivery_mode'] !== 'टपाल' &&
  //           data[index]['dis_mode'] == 'रेल्वे'
  //         ) {
  //           this.addToObject('रेल्वे', Object.keys(data1).length, totalsbhet);
  //         }  else if (
  //           data[index]['delivery_mode'] !== 'टपाल' &&
  //           data[index]['dis_mode'] == 'ट्रॅव्हल्स'
  //         ) {
  //           this.addToObject('ट्रॅव्हल्स', Object.keys(data1).length, totalsbhet);
  //         } else if (
  //   (
  //     (data[index]['dis_mode'] == 'टपाल' &&
  //       data[index]['delivery_mode'] !== 'टपाल') ||
  //     data[index]['delivery_mode'] == 'टपाल'
  //   ) &&
  //   (data[index]['dis_sub_mode'] === 'रजिस्टर पोस्ट' ||
  //    data[index]['dis_sub_mode'] === 'जी.पी.ओ')
  // ) {
  //   this.addToObject('पोस्ट', Object.keys(data1).length, totalsbhet);
  // }

  //       }
  //     }

  //     // setTimeout(() => {
  //     let totalVprati = 0;
  //     let totalVkprati = 0;
  //     let totalSbhet = 0;
  //     let totalAikun = 0;
  //     this.tempData.map((a) => {
  //       totalVprati += a.vprati;
  //       totalVkprati += a.vkprati;
  //       totalSbhet += a.sbprati;
  //       totalAikun += a.aikun;
  //     });
  //     this.tempDataTotal['totalVprati'] = totalVprati;
  //     this.tempDataTotal['totalVkprati'] = totalVkprati;
  //     this.tempDataTotal['totalSbhet'] = totalSbhet;
  //     this.tempDataTotal['totalAikun'] = totalAikun;
  //     // console.log(this.tempData);
  //     // }, 1500);
  //   }


 

  //Correct Code 
  // addToObject(name: string, varganiCount: number, sbhet: number) {
  //   let data = this.tempData.find(a => a.name.toLowerCase() === name.toLowerCase());
  //   if (!data) return;

  //   if (name === 'पोस्ट') {
  //     // ✅ पोस्ट row: show allAdditionTotal in vprati
  //     data.vprati = sbhet;      // override directly with allAdditionTotal
  //     data.sbprati = 0;         // no accumulation in sbprati
  //     data.aikun = data.vprati; // aikun = vprati only

  //     // ✅ Track globally
  //     this.tempDataTotal.allAdditionTotal = sbhet;
  //   } else {
  //     // ✅ Normal accumulation for other rows
  //     data.vprati = (data.vprati || 0) + varganiCount;
  //     data.sbprati = (data.sbprati || 0) + sbhet;
  //     data.aikun = (data.vprati || 0) + (data.sbprati || 0);
  //   }
  // }








  //OLD Code 
  // addToObject(name: string, varganiCount: number, sbhet: number) {
  //   let data = this.tempData.find((a) => {
  //     return a.name.toLowerCase().indexOf(name.toLowerCase()) > -1;
  //   });
  //   // console.log(data);

  //   data['vprati'] += varganiCount;
  //   data['sbprati'] += sbhet;
  //   data['aikun'] += varganiCount + sbhet;
  //   // this.tempData.push({
  //   //   name: name,
  //   //   vprati: varganiCount,
  //   //   vkprati: 0,
  //   //   sbprati: sbhet,
  //   //   aikun: varganiCount + sbhet,
  //   // });
  // }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  setJavakData() {
    const req1: any = { issue_date_to: this.endDate };

    this.service.getJavakDataFromAllDistCopies(req1).subscribe({
      next: (response: any) => {
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.warn('No data found for Javak', response);
          this.printJavakData = [];
          this.tempData = [];
          return;
        }

        this.printJavakData = response.data;
        console.log(this.printJavakData)

        // ✅ Reset totals
        this.tempDataTotal = {
          name: 'Total',
          totalVprati: 0,
          totalVkprati: 0,
          totalSbhet: 0,
          totalAikun: 0,
          allAdditionTotal: 0,
          totalJadaAnk: 0,
          totalJadaSale: 0,
          totalJadaSBhet: 0
        };

        const deliveryGroups = this.uniqueData(this.printJavakData, (a: any) => a.delivery_mode);

        deliveryGroups.forEach((dg: any) => {
          const subData = this.printJavakData.filter(a => a.delivery_mode === dg.delivery_mode);
          const disModes = this.uniqueData(subData, (a: any) => a.dis_mode);

          disModes.forEach((dm: any) => {
            const data1 = subData.filter(a => a.dis_mode === dm.dis_mode);

            // ✅ Correct totals
            const totalsbhet = data1.reduce((sum, a) => sum + (a.s_bhet ? parseInt(a.s_bhet) : 0), 0);
            const totalsubcount = data1.reduce((sum, a) => sum + (a.sub_count ? parseInt(a.sub_count) : 0), 0);
            const totalsales = data1.reduce((sum, a) => sum + (a.sale ? parseInt(a.sale) : 0), 0);

            const totalJadaAnk = data1.reduce((sum, a) => sum + (a.input_value ? parseInt(a.input_value) : 0), 0);
            const totalJadaVikri = data1.reduce((sum, a) => sum + (a.input_value1 ? parseInt(a.input_value1) : 0), 0);
            const totalJadaSBhet = data1.reduce((sum, a) => sum + (a.input_value2 ? parseInt(a.input_value2) : 0), 0);

            switch (dm.dis_mode) {
              case 'हस्ते':
              case 'ट्रान्सपोर्ट':
              case 'एस . टी':
              case 'एस. टी':
              case 'रेल्वे':
              case 'ट्रॅव्हल्स':
                if (dg.delivery_mode !== 'टपाल') {
                  this.addToObject(dm.dis_mode, totalsubcount, totalsbhet, totalsales, totalJadaAnk, totalJadaVikri, totalJadaSBhet);
                }
                break;

                // Old Correct Code
              // case 'टपाल':
              //   if (dm.dis_sub_mode === 'रजिस्टर पोस्ट' || dm.dis_sub_mode === 'जी.पी.ओ') {
              //     // ✅ All टपाल → पोस्ट पार्सल
              //     this.addToObject('पोस्ट पार्सल', totalsubcount, totalsbhet, totalsales, totalJadaAnk, totalJadaVikri, totalJadaSBhet);

              //     // ✅ जी.पी.ओ → update पोस्ट row with allAdditionTotal
              //     if (dm.dis_sub_mode === 'जी.पी.ओ' && data1.length > 0 && data1[0].allAdditionTotal != null) {
              //       const allAdditionTotal = parseInt(data1[0].allAdditionTotal) || 0;

              //       // ✅ Pass allAdditionTotal properly to "पोस्ट"
              //       this.addToObject('पोस्ट', allAdditionTotal, 0, 0, 0, 0, 0);

              //       // ✅ Update tempDataTotal correctly
              //       this.tempDataTotal.allAdditionTotal += allAdditionTotal;

              //     }
              //   }
              //   break;

              case 'टपाल': {

                // Existing logic
                this.addToObject('पोस्ट पार्सल', totalsubcount, totalsbhet, totalsales, totalJadaAnk, totalJadaVikri, totalJadaSBhet);

                // Check whether any GPO record exists
                const gpoRow = data1.find((x: any) => x.dis_sub_mode === 'जी.पी.ओ');

                if (gpoRow && gpoRow.allAdditionTotal != null) {

                  const allAdditionTotal = Number(gpoRow.allAdditionTotal) || 0;

                  this.addToObject('पोस्ट', allAdditionTotal, 0, 0, 0, 0, 0);

                  this.tempDataTotal.allAdditionTotal += allAdditionTotal;
                }

                break;
              }
            }
          });
        });

        // ✅ Calculate overall totals
        this.tempData.forEach(a => {
          this.tempDataTotal.totalVprati += a.vprati || 0;
          this.tempDataTotal.totalVkprati += a.vkprati || 0;
          this.tempDataTotal.totalSbhet += a.sbprati || 0;
          this.tempDataTotal.totalAikun += a.aikun || 0;

          this.tempDataTotal.totalJadaAnk += a.jadaAnk || 0;
          this.tempDataTotal.totalJadaSale += a.jadaSale || 0;
          this.tempDataTotal.totalJadaSBhet += a.jadaSBhet || 0;
        });
      },
      error: (err) => console.error('Error fetching Javak Data', err)
    });
  }


  addToObject(name: string, varganiCount: number, sbhet: number, sale: number, jadaAnk: number, jadaSale: number, jadaSBhet: number) {
    let data = this.tempData.find(a => a.name.toLowerCase() === name.toLowerCase());

    // ✅ Auto-create if not found (especially needed for "पोस्ट")
    if (!data) {
      data = {
        name,
        vprati: 0,
        sbprati: 0,
        vkprati: 0,
        jadaAnk: 0,
        jadaSale: 0,
        jadaSBhet: 0,
        aikun: 0
      };
      this.tempData.push(data);
    }

    if (name === 'पोस्ट') {
      // ✅ Always show allAdditionTotal in vprati column
      data.vprati = varganiCount || 0; // This receives allAdditionTotal
      data.sbprati = 0;
      data.vkprati = 0;
      data.jadaAnk = 0;
      data.jadaSale = 0;
      data.jadaSBhet = 0;
      data.aikun = data.vprati;

      // ✅ Totals handled separately below; do NOT double-add
    } else {
      // ✅ Original logic for all other rows
      data.vprati = (data.vprati || 0) + (varganiCount || 0);
      data.sbprati = (data.sbprati || 0) + (sbhet || 0);
      data.vkprati = (data.vkprati || 0) + (sale || 0);
      data.jadaAnk = (data.jadaAnk || 0) + (jadaAnk || 0);
      data.jadaSale = (data.jadaSale || 0) + (jadaSale || 0);
      data.jadaSBhet = (data.jadaSBhet || 0) + (jadaSBhet || 0);
      data.aikun = (data.vprati || 0) + (data.sbprati || 0) + (data.vkprati || 0) + (data.jadaAnk || 0) + (data.jadaSale || 0) + (data.jadaSBhet || 0);
    }
  }

}
